module.exports = __webpack_public_path__ + "static/media/Aldsworth Dresser (5).ef55bcd8.JPG";